function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e42e44;}.cls-2{fill:#fff;}.cls-3{fill:#bc2742;}.cls-4{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:20px;}.cls-5{fill:#49494a;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M359.51,143.09l-7.3-40.43A212.88,212.88,0,0,0,223.77,59.79c-118.1,0-213.84,95.74-213.84,213.84s95.74,213.84,213.84,213.84,213.84-95.74,213.84-213.84A212.82,212.82,0,0,0,398.33,150.1Z"
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-2",
  cx: 223.77,
  cy: 273.63,
  r: 165.2,
  transform: "translate(-127.95 238.37) rotate(-45)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M398.33,150.1l-37.55-6.78a212.86,212.86,0,0,1,44.35,130.31c0,112.63-87.1,204.85-197.6,213.16,5.36.41,10.77.68,16.24.68,118.1,0,213.84-95.74,213.84-213.84A212.82,212.82,0,0,0,398.33,150.1Z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M359.19,141.29l-7-38.63A212.88,212.88,0,0,0,223.77,59.79c-5.47,0-10.88.27-16.24.68A213.42,213.42,0,0,1,359.19,141.29Z"
});

var _ref7 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-4",
  cx: 223.77,
  cy: 273.63,
  r: 165.2,
  transform: "translate(-127.95 238.37) rotate(-45)"
});

var _ref8 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-1",
  cx: 223.77,
  cy: 273.63,
  r: 114.58,
  transform: "translate(-127.95 238.37) rotate(-45)"
});

var _ref9 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-4",
  cx: 223.77,
  cy: 273.63,
  r: 114.58,
  transform: "translate(-127.95 238.37) rotate(-45)"
});

var _ref10 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-2",
  cx: 223.77,
  cy: 273.63,
  r: 56.91,
  transform: "translate(-127.95 238.37) rotate(-45)"
});

var _ref11 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-4",
  cx: 223.77,
  cy: 273.63,
  r: 56.91,
  transform: "translate(-127.95 238.37) rotate(-45)"
});

var _ref12 = /*#__PURE__*/React.createElement("polygon", {
  className: "cls-5",
  points: "359.51 143.09 348.55 82.4 418.43 12.53 429.38 73.22 359.51 143.09"
});

var _ref13 = /*#__PURE__*/React.createElement("polygon", {
  className: "cls-5",
  points: "359.51 143.09 420.2 154.05 490.07 84.18 429.38 73.22 359.51 143.09"
});

var _ref14 = /*#__PURE__*/React.createElement("line", {
  className: "cls-4",
  x1: 405.58,
  x2: 223.77,
  y1: 97.02,
  y2: 278.83
});

var _ref15 = /*#__PURE__*/React.createElement("polygon", {
  className: "cls-4",
  points: "359.51 143.09 348.55 82.4 418.43 12.53 429.38 73.22 359.51 143.09"
});

var _ref16 = /*#__PURE__*/React.createElement("polygon", {
  className: "cls-4",
  points: "359.51 143.09 420.2 154.05 490.07 84.18 429.38 73.22 359.51 143.09"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M359.51,143.09l-7.3-40.43A212.88,212.88,0,0,0,223.77,59.79c-118.1,0-213.84,95.74-213.84,213.84s95.74,213.84,213.84,213.84,213.84-95.74,213.84-213.84A212.82,212.82,0,0,0,398.33,150.1Z"
});

function SvgTarget(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    id: "Layer_1",
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _ref2, title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTarget);
export default __webpack_public_path__ + "static/media/target.1c238498.svg";
export { ForwardRef as ReactComponent };